module.exports = __webpack_public_path__ + "static/media/basic_networking.9784fe5c.jpg";